export const CONTINUE_TO_BILLING_LABEL = 'Proceed to payment';
export const PAYMENT_LABEL = 'Complete payment';
export const EXIT_CHECKOUT_LABEL = 'Cancel';
export const PREVIOUS_STEP_LABEL = 'Back';
